module.exports = "운임관리리스트\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/fare/rate/list/fare-rate-list.html
// module id = ./src/app/containers/fare/rate/list/fare-rate-list.html
// module chunks = 1